<template>
  <svg
    width="20px"
    height="16px"
    viewBox="0 0 20 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Link-small" transform="translate(-122.000000, -7.000000)" fill="currentColor">
        <g
          id="Actions-/-Navigation-/-arrow--right-/-24"
          transform="translate(120.000000, 3.000000)"
        >
          <polygon
            id="Fill"
            points="14 4 12.9 5.1 18.9 11.2 2 11.2 2 12.8 18.9 12.8 12.9 18.9 14 20 22 12"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'ArrowRight24'
};
</script>
